import { tjipKeyGuardDirective } from './TjipKeyGuardDirectiveData';

export default function AppDirectives(Vue: any) {
  Vue.directive('app-keyguard', tjipKeyGuardDirective);
}
